import React from 'react';

import OnboardingContainer from 'buyside/components/container/Onboarding/OnboardingContainer';

const OnboardingRoot = () => {
  return <OnboardingContainer />;
};

export default OnboardingRoot;
